<div class="container single-view" id="add-customer">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/customers/" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'CUSTOMERS.BTN_BACK_TO_CUSTOMER' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-customer-title" class="section-title">{{ 'CUSTOMER_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-customer-subtitle" class="section-subtitle mt-1 text-base">{{ 'CUSTOMER_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form class="mt-0" [formGroup]="customerDetailsFormGroup" data-testid="add-customer-form">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="add-customer-details" class="border-b pb-3">{{ 'CUSTOMER_CREATE.CUSTOMER_DETAILS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mt-1">
                  <label data-testid="add-customer-field-firstname" class="block text-sm" for="firstname">{{ 'CUSTOMER_CREATE.FIRST_NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-customer-firstname-input" type="text" id="firstname" formControlName="firstname" autocomplete="off">
                  @if (customerDetailsFormGroup.get('firstname')?.invalid && customerDetailsFormGroup.get('firstname')?.touched) {
                    @if (!customerDetailsFormGroup.get('firstname')?.errors?.['invalidCharacters']) {
                      <small data-testid="firstname-mandatory" class="p-error">{{
                      'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mt-1">
                  <label data-testid="add-customer-field-romanisedfirstname" class="block text-sm" for="romanisedFirstName">{{ 'CUSTOMER_CREATE.ROMANIZED_FIRST_NAME' | translate }}</label>
                  <input data-testid="add-customer-romanisedfirstname-input" type="text" id="romanisedFirstName" formControlName="romanisedFirstName" autocomplete="off">
                  @if (customerDetailsFormGroup.get('romanisedFirstName')?.invalid && customerDetailsFormGroup.get('romanisedFirstName')?.touched) {
                    @if (customerDetailsFormGroup.get('romanisedFirstName')?.errors?.['invalidCharacters']) {
                      <small data-testid="romanisedfirstname-format" class="p-error">
                        {{ 'CUSTOMER_CREATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                      </small>
                    }
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mt-1">
                  <label data-testid="add-customer-field-lastname"  class="block text-sm" for="lastname">{{ 'CUSTOMER_CREATE.LAST_NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-customer-lastname-input" type="text" id="lastname" formControlName="lastname" autocomplete="off">
                  @if (customerDetailsFormGroup.get('lastname')?.invalid && customerDetailsFormGroup.get('lastname')?.touched) {
                    @if (!customerDetailsFormGroup.get('lastname')?.errors?.['invalidCharacters']) {
                      <small data-testid="lastname-mandatory" class="p-error">{{
                      'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-customer-field-romanisedlastname" class="block text-sm" for="romanisedLastName">{{ 'CUSTOMER_CREATE.ROMANIZED_LAST_NAME' | translate }} </label>
                  <input data-testid="add-customer-romanisedlastname-input" type="text" id="romanisedLastName" formControlName="romanisedLastName" autocomplete="off">
                  @if (customerDetailsFormGroup.get('romanisedLastName')?.invalid && customerDetailsFormGroup.get('romanisedLastName')?.touched) {
                    @if (customerDetailsFormGroup.get('romanisedLastName')?.errors?.['invalidCharacters']) {
                      <small data-testid="romanisedlastname-format" class="p-error">
                        {{ 'CUSTOMER_CREATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                      </small>
                    }
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mt-1">
                  <label data-testid="add-customer-field-email" class="block text-sm" for="email">{{ 'CUSTOMER_CREATE.EMAIL' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-customer-email-input" type="text" id="email" formControlName="email" tabindex="16" autocomplete="off">
                  @if (customerDetailsFormGroup.get('email')?.invalid && (customerDetailsFormGroup.get('email')?.dirty || customerDetailsFormGroup.get('email')?.touched)) {
                    @if (customerDetailsFormGroup.get('email')?.hasError('required')) {
                      <small data-testid="email-mandatory" class="p-error">{{ 'YOUR_ACCOUNT.VALIDATE_EMAIL'
                      | translate }}</small>
                    }
                    @if (customerDetailsFormGroup.get('email')?.errors?.['invalidEmail']) {
                      <small data-testid="email-format" class="p-error">{{
                      'YOUR_ACCOUNT.VALIDATE_EMAIL_SYNTAX' | translate }}</small>
                    }
                  }
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mt-1">
                  <label data-testid="add-customer-field-gender" for="gender">{{ 'CUSTOMER_CREATE.GENDER' | translate }}</label>
                  <app-custom-dropdown
                    data-testid="selector-input-gender"
                    [placeholder]="'CUSTOMER_CREATE.SELECT_GENDER_PLACEHOLDER' | translate"
                    [options]="genders"
                    optionLabel="label"
                    optionValue="value"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showSearchbox]="true"
                    [showClear]="true"
                    [searchMode]="'local'"
                    [pageSize]="10"
                    formControlName="gender">
                  </app-custom-dropdown>
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mt-1">
                  <label data-testid="add-customer-field-birthdate" class="block text-sm" for="birthdate">{{ 'CREATE_CUSTOMER.BIRTHDATE' | translate }}</label>
                  <div class="mt-2">
                    <p-datepicker data-testid="add-customer-birthdate-input" formControlName="birthDate" dateFormat="dd/mm/yy " [maxDate]="currentDate"
                      placeholder="{{ 'MODALBOXES.BIRTHDATE_PLACEHOLDER' | translate }}" showIcon="true" appendTo="body"
                      inputId="birthdate" />
                  </div>
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mt-1">
                  <p data-testid="add-customer-field-foreign" class="mb-2 label">{{ 'CUSTOMER_CREATE.FOREIGN_CUSTOMER' | translate }}</p>
                  <div class="flex flex-row">
                    <span data-testid="add-customer-foreign-radio-label-yes" class="inline-flex mr-6">
                      <p-radioButton name="foreign" value="true" formControlName="foreign" inputId="is-foreigner-yes" />
                      <label for="is-foreigner-yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</label>
                    </span>
                    <span data-testid="add-customer-foreign-radio-label-no" class="inline-flex mr-2">
                      <p-radioButton  name="foreign" value="false" formControlName="foreign" inputId="is-foreigner-no" />
                      <label for="is-foreigner-no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</label>
                    </span>
                  </div>
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mt-1">
                  <label data-testid="add-customer-field-country" class="block text-sm" for="country">{{ 'CUSTOMER_CREATE.COUNTRY' | translate }}</label>
                  <app-custom-dropdown
                    data-testid="add-customer-country-input"
                    [options]="countries"
                    optionLabel="translationKey"
                    optionValue="alpha2"
                    [translateOptionLabel]="true"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showSearchbox]="true"
                    [showClear]="true"
                    [searchMode]="'local'"
                    [pageSize]="10"
                    [placeholder]="'CUSTOMER_CREATE.COUNTRY' | translate"
                    formControlName="country">
                  </app-custom-dropdown>
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mt-1">
                  <label data-testid="add-customer-field-address" class="block text-sm" for="address">{{ 'CUSTOMER_CREATE.ADDRESS' | translate }}</label>
                  <input data-testid="add-customer-address-input"  type="text" id="address" formControlName="address" autocomplete="off">
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mt-1">
                  <label data-testid="add-customer-field-postalcode" class="block text-sm" for="postalCode">{{ 'CUSTOMER_CREATE.POSTAL_CODE' | translate }}</label>
                  <input data-testid="add-customer-postalcode-input" type="text" id="postalCode" formControlName="postalCode" autocomplete="off">
                </div>
              </div>
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 class="border-b pb-3">{{ 'CUSTOMER_SINGLE_VIEW.BRAND_INFORMATION' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pb-1 justify-end">
                  <div class="flex flex-row">
                    <p-checkbox data-testid="add-customer-wantemails-input" formControlName="wantEmails"
                      inputId="wantEmails" binary="true" />

                    <label for="wantEmails" class="ml-2">
                      {{ 'CUSTOMER_CREATE.WANT_EMAILS_PREFIX' | translate }}
                      <a>{{ 'CUSTOMER_CREATE.WANT_EMAILS_COMMUNICATIONS' | translate }}</a>
                    </label>
                  </div>
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pb-1 justify-end">
                  <div class="flex flex-row">
                    <p-checkbox data-testid="add-customer-acceptprivacypolicy-input" formControlName="acceptedPrivacyPolicy" inputId="acceptedPrivacyPolicy" binary="true" />

                    <label for="acceptedPrivacyPolicy" class="ml-2">
                      {{ 'CUSTOMER_CREATE.WANT_EMAILS_PREFIX' | translate }}
                      @if (companyLinks.brandPrivacy) {
                        <a [href]="companyLinks.brandPrivacy"
                        target="_blank" rel="noopener noreferrer" class="link">{{ 'CUSTOMER_CREATE.BRAND_PRIVACY_POLICY' | translate }}</a>
                      } @else {
                        {{ 'CUSTOMER_CREATE.BRAND_PRIVACY_POLICY' | translate }}
                      }
                    </label>
                  </div>
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pb-1 justify-end mt-4">
                  <div class="flex flex-row">
                    <p-checkbox data-testid="add-customer-acceptterms-input" formControlName="acceptedTerms" inputId="acceptedTerms" binary="true" />
                    <label for="acceptedTerms" class="ml-2">
                      {{ 'CUSTOMER_CREATE.TOS_ACCEPTED_PREFIX' | translate }}
                      @if (companyLinks.brandTerms) {
                        <a [href]="companyLinks.brandTerms" target="_blank"
                        rel="noopener noreferrer" class="link">{{ 'CUSTOMER_CREATE.BRAND_TERMS_OF_SERVICE' | translate }}</a>
                      } @else {
                        {{ 'CUSTOMER_CREATE.BRAND_TERMS_OF_SERVICE' | translate }}
                      }
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-customer--create-customer-button" class="btn primary-btn" [disabled]="customerDetailsFormGroup.invalid" (click)="submitForm()">{{
                    'CUSTOMER_CREATE.BTN_ADD_NEW_CUSTOMER' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
